import { render, staticRenderFns } from "./mappingDomainList.vue?vue&type=template&id=00f8864e&scoped=true"
import script from "./mappingDomainList.vue?vue&type=script&lang=js"
export * from "./mappingDomainList.vue?vue&type=script&lang=js"
import style0 from "./mappingDomainList.vue?vue&type=style&index=0&id=00f8864e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f8864e",
  null
  
)

export default component.exports